import {
  AnvilSelectOptionsProps,
  Form,
  Headline,
} from '@servicetitan/design-system';
import { useController, useFieldArray, useFormContext } from 'react-hook-form';
import {
  CreateCustomerFormValues,
  payeeOptions,
} from '../../CreateCustomerFormDefinitions';
import strings from '../../strings';
import ContactMethodForm from '@components/forms/components/ContactMethodForm/ContactMethodForm';
import AddressFormManager from '@components/forms/components/AddressFormManager';

/**
 * Renders a form for entering billing information.
 */
const BillingForm = () => {
  const {
    register,
    setValue,
    control,
    trigger,
    formState: { errors },
  } = useFormContext<CreateCustomerFormValues>();

  const { field: payeeField } = useController({ control, name: 'payee' });

  const fieldArray = useFieldArray<CreateCustomerFormValues>({
    control,
    name: 'billingCustomer.contacts',
  });

  const { update, append, remove, fields } = fieldArray;

  // all billing fields will be keyed on 'billingCustomer'
  const billingFormPrefix = 'billingCustomer';

  return (
    <>
      <Headline className='m-b-3' size='small'>
        {strings.headlines.payee}
      </Headline>
      <Form.AnvilSelect
        required
        options={payeeOptions}
        trigger={{
          size: 'small',
          placeholder: strings.placeholders.payee,
          clearable: false,
        }}
        value={payeeField.value}
        onChange={(data) =>
          setValue('payee', (data as AnvilSelectOptionsProps).value, {
            shouldDirty: true,
          })
        }
      />
      {payeeField.value === 'billingCustomer' && (
        <>
          <Form.Input
            required
            label={strings.labels.customerName}
            placeholder={strings.placeholders.billingName}
            small
            error={errors[billingFormPrefix]?.name?.message}
            {...register(`${billingFormPrefix}.name`)}
            onBlur={() => trigger(`${billingFormPrefix}.name`)}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setValue(`${billingFormPrefix}.name`, e.target.value)
            }
          />
          <AddressFormManager formFieldPrefix={billingFormPrefix} />
          <ContactMethodForm
            formFieldPrefix={billingFormPrefix}
            append={append}
            update={update}
            remove={remove}
            contactMethodFields={fields}
          />
        </>
      )}
    </>
  );
};

export default BillingForm;
